import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderMobileDiscountsModal = (data?: { isRebrandingQuotaLanding: boolean }) =>
    openPopupHelper({ popupName: popupNames.MOBILE_DISCOUNTS, data });
